/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Elsewhere_TitleInputs */

const en_contact_elsewhere_title = /** @type {(inputs: Contact_Elsewhere_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for something else?`)
};

const lv_contact_elsewhere_title = /** @type {(inputs: Contact_Elsewhere_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meklējat ko citu?`)
};

/**
* | output |
* | --- |
* | "Looking for something else?" |
*
* @param {Contact_Elsewhere_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_elsewhere_title = /** @type {((inputs?: Contact_Elsewhere_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Elsewhere_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_elsewhere_title(inputs)
	return en_contact_elsewhere_title(inputs)
});